import React from 'react';
import Title from './Title';
import Typography from '@material-ui/core/Typography';
import { Container, Grid } from '@material-ui/core';

const data = [
  {
    Name: "Citradelic IPA",
    BrewDate: "Brewed on 2 February, 2021",
    Style: "Style: Indian Pale Ale",
    OriginalGravity: "OG: 1.065",
    FinalGravity: "FG: TBD",
    ABV: "",
    Hops: ["Citra", "Mosaic", "Nugget"]
  },
  {
    Name: "Chinook IPA",
    BrewDate: "Brewed on 2 February, 2021",
    Style: "Style: Indian Pale Ale",
    OriginalGravity: "OG: 1.065",
    FinalGravity: "FG: TBD",
    ABV: "",
    Hops: ["Citra", "Mosaic", "Nugget"]
  }
];


export default function UpcomingBrews() {
  return (
    <Container>
        {data.map((brew, index) => (
          <Grid item>
            <Title>Upcoming Brew</Title>
            <Typography component="p" variant="h4">
              {brew.Name}
            </Typography>
            <Typography color="textSecondary"> 
              {brew.BrewDate}
            </Typography>
            <Typography color="textSecondary"> 
              {brew.Style}
            </Typography>
            <Typography color="textSecondary"> 
              {brew.OriginalGravity}
            </Typography>
            <Typography color="textSecondary"> 
            { brew.FinalGravity}
            </Typography>
          </Grid >
          ))}      
    </Container>
  );
}
